import { useWatch } from 'react-hook-form';
import { ValidityType } from 'src/modules/generated/api';

export const useWatchSummary = () => ({
  normalizedBrand: useWatch({ name: 'normalizedBrand' }) ?? [],
  normalizedModel: useWatch({ name: 'normalizedModel' }) ?? [],
  normalizedEquipmentLine: useWatch({ name: 'normalizedEquipmentLine' }) ?? [],
  normalizedVersion: useWatch({ name: 'normalizedVersion' }) ?? [],
  equipmentCodes: useWatch({ name: 'equipmentCodes' }) ?? [],
  promotions: useWatch({ name: 'promotions' }) ?? [],
  normalizedFuelDetail: useWatch({ name: 'normalizedFuelDetail' }) ?? [],
  kvps: useWatch({ name: 'kvps' }) ?? [],
  originSources: useWatch({ name: 'originSource' }) ?? [], // renaming is necessary
  originSourceGroups: useWatch({ name: 'originSourceGroups' }) ?? [],
  validity: useWatch({ name: 'validity' }) ?? ValidityType.All,
});

export const useBidsWatchSummary = () => ({
  normalizedBrand: useWatch({ name: 'carsRequest.normalizedBrand' }) ?? [],
  normalizedModel: useWatch({ name: 'carsRequest.normalizedModel' }) ?? [],
  normalizedEquipmentLine: useWatch({ name: 'carsRequest.normalizedEquipmentLine' }) ?? [],
  normalizedVersion: useWatch({ name: 'carsRequest.normalizedVersion' }) ?? [],
  equipmentCodes: useWatch({ name: 'carsRequest.equipmentCodes' }) ?? [],
  promotions: useWatch({ name: 'carsRequest.promotions' }) ?? [],
  normalizedFuelDetail: useWatch({ name: 'carsRequest.normalizedFuelDetail' }) ?? [],
  bidCreatorUserId: useWatch({ name: 'bidCreatorUserId' }) ?? [],
  bidCreatorDealerCountry: useWatch({ name: 'bidCreatorDealerCountry' }) ?? [],
  bidCreatorDealerId: useWatch({ name: 'bidCreatorDealerId' }) ?? [],
  kvps: useWatch({ name: 'carsRequest.kvps' }) ?? [],
  biddingKvps: useWatch({ name: 'biddingKvps' }) ?? [],
  originSources: useWatch({ name: 'carsRequest.originSource' }) ?? [], // renaming is necessary
  originSourceGroups: useWatch({ name: 'carsRequest.originSourceGroups' }) ?? [],
});
